/**
 * H-LINK online state from the backend's per-device `status` ("online" / "offline").
 * Payloads without a status (older backends) count a device in the live stream as online.
 */
export const isDeviceOnline = (device) => {
  if (!device) return false;
  const status = String(device.status ?? device.device_info?.status ?? "").trim().toLowerCase();
  return status ? status === "online" : true;
};
